import React from 'react'

const Home = () => {
  return (
    <>
      <h1 className='title'>Welcome to Salary Manager</h1>
      <p>click on <b>Dashboard</b> to access the assingment</p>
    </>
  )  
}

export default Home;